import {
  ThemeProvider
} from "./chunk-BFR7XAZI.mjs";

// src/julo-provider/JuloProvider.tsx
import { jsx } from "react/jsx-runtime";
var JuloProvider = (props) => {
  const { children, theme } = props;
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children });
};
var JuloProvider_default = JuloProvider;

export {
  JuloProvider_default
};
